import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { track } from "@/lib/track";
import { useSectionView } from "@/hooks/use-section-view";
import ClientLogos from "./ClientLogos";

const CASE_URL = "/case-study/eleeva-it";


const ResultsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sectionRef = useSectionView<HTMLElement>("results");
  const rows = t("results.rows", { returnObjects: true }) as Array<{
    label: string;
    before: string;
    after: string;
  }>;

  return (
    <section ref={sectionRef} id="resultados" className="py-20 lg:py-32 bg-gradient-to-br from-primary/5 to-background scroll-mt-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <p className="inline-block px-4 py-1.5 mb-4 rounded-full bg-accent text-sm font-medium text-foreground">
            {t("results.eyebrow")}
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            {t("results.title")} <span className="text-primary">{t("results.titleHighlight")}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("results.subtitle")}
          </p>
        </div>

        <div className="max-w-3xl mx-auto rounded-2xl border border-border bg-card overflow-hidden animate-scale-in">
          <div className="grid grid-cols-[1.4fr_1fr_1fr] bg-accent/50 px-4 sm:px-6 py-3 text-sm font-semibold">
            <span>{t("results.metric")}</span>
            <span className="text-center text-muted-foreground">{t("results.before")}</span>
            <span className="text-center">{t("results.after")}</span>
          </div>
          {rows.map((row) => (
            <div
              key={row.label}
              className="grid grid-cols-[1.4fr_1fr_1fr] items-center px-4 sm:px-6 py-5 border-t border-border"
            >
              <span className="font-medium">{row.label}</span>
              <span className="text-center text-lg text-muted-foreground line-through decoration-muted-foreground/50">
                {row.before}
              </span>
              <span className="text-center text-2xl sm:text-3xl font-bold text-foreground">
                {row.after}
              </span>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 animate-fade-in">
          <Button variant="outline" size="lg" className="group" onClick={() => { track("case_click", { location: "results" }); navigate(CASE_URL); }}>
            {t("results.readCase")}
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        <div className="mt-20">
          <ClientLogos />
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
